import { render, staticRenderFns } from "./myjl.vue?vue&type=template&id=b47460ec&scoped=true"
import script from "./myjl.vue?vue&type=script&lang=js"
export * from "./myjl.vue?vue&type=script&lang=js"
import style0 from "./myjl.vue?vue&type=style&index=0&id=b47460ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47460ec",
  null
  
)

export default component.exports